import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import GuildPage from './components/GuildPage';
import AboutPage from './components/AboutPage';
import LoginPage from './components/LoginPage';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import DisplayMode from './components/DisplayMode';
import LandingPage from './components/LandingPage';
import RoomLobby from './components/RoomLobby';
import CharacterCreator from './components/CharacterCreator';

// Extract token from URL BEFORE React renders
const params = new URLSearchParams(window.location.search);
const token = params.get('token');
const wantsUpgrade = params.get('upgrade') === 'true';
const upgradePlan = params.get('plan') || 'pro';
if (token) {
  localStorage.setItem('session', token);
  if (wantsUpgrade) { localStorage.setItem('pending_upgrade', 'true'); localStorage.setItem('pending_plan', upgradePlan); }
  window.history.replaceState({}, '', window.location.pathname);
}

// Clear expired tokens so users see landing page instead of broken dashboard
const existing = localStorage.getItem('session');
if (existing) {
  try {
    const part = existing.split('.')[1];
    const payload = JSON.parse(atob(part + '='.repeat((4 - part.length % 4) % 4)));
    if (payload.exp && payload.exp < Date.now() / 1000) localStorage.removeItem('session');
  } catch { localStorage.removeItem('session'); }
}

function GuildRoute() {
  const slug = window.location.pathname.split('/guild/')[1];
  return <GuildPage slug={slug} />;
}

function JoinRoute() {
  const code = window.location.pathname.split('/join/')[1];
  const token = localStorage.getItem('session');
  if (!token) {
    localStorage.setItem('pending_join', code);
    window.location.href = '/login';
    return null;
  }
  return <RoomLobby onEnterRoom={(id, role, isNewJoin) => { localStorage.setItem('active_room', id); if (isNewJoin && role === 'player') { window.location.href = `/create-character?room=${id}`; } else { window.location.href = '/'; } }} autoJoin={code} />;
}

function CreateCharRoute() {
  const params = new URLSearchParams(window.location.search);
  const roomId = params.get('room');
  if (!roomId) return <div style={{color:'#f4e8c1',padding:'40px',textAlign:'center'}}>No room specified.</div>;
  return <CharacterCreator roomId={roomId} onComplete={() => { localStorage.setItem('active_room', roomId); window.location.href = '/'; }} />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/guild/:slug" element={<GuildRoute />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/pricing" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage onLogin={() => { const pending = localStorage.getItem('pending_join'); if (pending) { localStorage.removeItem('pending_join'); window.location.href = `/join/${pending}`; } else { window.location.href = '/rooms'; } }} />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/display/:code" element={<DisplayMode />} />
      <Route path="/rooms" element={<RoomLobby onEnterRoom={(id, role, isNewJoin) => { localStorage.setItem('active_room', id); if (isNewJoin && role === 'player') { window.location.href = `/create-character?room=${id}`; } else { window.location.href = '/'; } }} />} />
      <Route path="/create-character" element={<CreateCharRoute />} />
      <Route path="/join/:code" element={<JoinRoute />} />
      <Route path="*" element={<App />} />
    </Routes>
  </BrowserRouter>
);
